import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
import {NOTIFICATION_QUERY_PARAM} from '../../global-constants/constants'
import {TOOL_SELECTOR_ROUTE} from '../../global-constants/routingConstants'
import {logUserIn} from '../../store/authentication/authentication.action'
import {AppDispatch} from '../../store/store'
import LoginForm from '../components/LoginForm'

function LoginFormContainer() {
  const dispatch = useDispatch<AppDispatch>()
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<Error | null>(null)
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <LoginForm
      error={error}
      submitting={submitting}
      onSubmit={credentials => {
        setSubmitting(true)
        setError(null)
        dispatch(logUserIn(credentials))
          .then(() => {
            setSubmitting(false)
            navigate(
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              (location.state && location.state.from) || TOOL_SELECTOR_ROUTE
            )
          })
          .catch(err => {
            setSubmitting(false)
            setError(err)
            console.error(err)
          })
      }}
      notificationType={new URLSearchParams(location.search).get(
        NOTIFICATION_QUERY_PARAM
      )}
      onClearError={() => setError(null)}
    />
  )
}

export default LoginFormContainer
